import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Upgrade() {
  const navigate = useNavigate()

  async function handleSignOut() {
    await supabase.auth.signOut()
    navigate('/')
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="nav">
        <div className="nav-content">
          <div
            className="nav-title"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
          >
            <span>&gt; AgencySniper</span>
          </div>
          <div className="nav-actions">
            <button onClick={() => navigate('/dashboard')} className="btn-secondary" style={{ padding: '10px 20px', fontSize: '14px' }}>
              Dashboard
            </button>
            <button onClick={handleSignOut} className="btn-secondary" style={{ padding: '10px 20px', fontSize: '14px' }}>
              Sign Out
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '16px', fontWeight: '700', color: '#98FB98', textShadow: '0 0 15px rgba(152, 251, 152, 0.7)', textAlign: 'center' }}>
            &gt; Premium Access Required
          </h2>
          <p style={{ color: 'rgba(152, 251, 152, 0.85)', marginBottom: '40px', fontSize: '16px', textAlign: 'center', lineHeight: '1.6', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
            The Agencies page is a premium feature
          </p>

          <div style={{
            padding: '32px',
            background: 'rgba(34, 139, 34, 0.2)',
            borderRadius: '16px',
            border: '2px solid rgba(152, 251, 152, 0.4)',
            boxShadow: '0 0 20px rgba(152, 251, 152, 0.2)',
            marginBottom: '32px'
          }}>
            <h3 style={{ fontSize: '24px', marginBottom: '24px', fontWeight: '700', color: '#98FB98', textShadow: '0 0 12px rgba(152, 251, 152, 0.6)' }}>
              Premium Benefits
            </h3>

            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{
                padding: '16px',
                marginBottom: '12px',
                background: 'rgba(34, 139, 34, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(152, 251, 152, 0.3)',
                color: '#F5F5F5',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <span style={{ color: '#98FB98', marginRight: '12px', fontSize: '20px' }}>✓</span>
                <strong style={{ color: '#98FB98' }}>50 Monthly Analyses</strong> - 10x more searches than free tier
              </li>

              <li style={{
                padding: '16px',
                marginBottom: '12px',
                background: 'rgba(34, 139, 34, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(152, 251, 152, 0.3)',
                color: '#F5F5F5',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <span style={{ color: '#98FB98', marginRight: '12px', fontSize: '20px' }}>✓</span>
                <strong style={{ color: '#98FB98' }}>Full Agencies Database</strong> - Browse and filter comprehensive list of known agencies
              </li>

              <li style={{
                padding: '16px',
                marginBottom: '12px',
                background: 'rgba(34, 139, 34, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(152, 251, 152, 0.3)',
                color: '#F5F5F5',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <span style={{ color: '#98FB98', marginRight: '12px', fontSize: '20px' }}>✓</span>
                <strong style={{ color: '#98FB98' }}>Deeper Analysis</strong> - Cross-verification and additional citations for enhanced accuracy
              </li>

              <li style={{
                padding: '16px',
                marginBottom: '12px',
                background: 'rgba(34, 139, 34, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(152, 251, 152, 0.3)',
                color: '#F5F5F5',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <span style={{ color: '#98FB98', marginRight: '12px', fontSize: '20px' }}>✓</span>
                <strong style={{ color: '#98FB98' }}>Priority Support</strong> - Get help when you need it
              </li>

              <li style={{
                padding: '16px',
                background: 'rgba(34, 139, 34, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(152, 251, 152, 0.3)',
                color: '#F5F5F5',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                <span style={{ color: '#98FB98', marginRight: '12px', fontSize: '20px' }}>✓</span>
                <strong style={{ color: '#98FB98' }}>Advanced Filtering</strong> - Search and filter your complete analysis history
              </li>
            </ul>
          </div>

          <div style={{
            padding: '24px',
            background: 'rgba(152, 251, 152, 0.1)',
            borderRadius: '12px',
            border: '2px solid rgba(152, 251, 152, 0.3)',
            textAlign: 'center',
            marginBottom: '28px'
          }}>
            <p style={{ color: '#F5F5F5', fontSize: '16px', marginBottom: '16px', lineHeight: '1.6' }}>
              To upgrade to Premium and access the Agencies database, please contact us at:
            </p>
            <a
              href="mailto:support@agencysniper.com"
              style={{
                color: '#98FB98',
                fontSize: '18px',
                fontWeight: '700',
                textDecoration: 'none',
                textShadow: '0 0 10px rgba(152, 251, 152, 0.6)'
              }}
            >
              support@agencysniper.com
            </a>
          </div>

          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => navigate('/dashboard')}
              className="btn"
              style={{ padding: '14px 32px', fontSize: '16px' }}
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
